import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TimeUtilsService {

  constructor(
  ) {
  }

  roundUpToMinutesMultipleOf(aDate: Date, multiplyFactor: number): Date {
    const minutesRoundedUp = Math.ceil(aDate.getTime() / (5 * 60 * 1000));
    return new Date(minutesRoundedUp * 5 * 60 * 1000);
  }

  addMinutes(aDate: Date, minutes: number): Date {
    return new Date(aDate.getTime() + minutes * 60 * 1000);
  }
}
